import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
export const DEFAULT_PURCHASE_CYCLE = {
  cycleType: CreativeOffer.CycleType.RECURRING,
  cycleDuration: {
    unit: CreativeOffer.DurationUnit.YEAR,
    count: 1
  }
};
//# sourceMappingURL=consts.js.map